const MONTH_IDX = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11,
};

export const clearRowError = (
  errorsModalsArr = [],
  modalIndex,
  rowIndex,
  field
) => {
  const next = errorsModalsArr.map((arr = []) =>
    arr.map((obj = {}) => ({ ...obj }))
  );
  if (next?.[modalIndex]?.[rowIndex]) {
    delete next[modalIndex][rowIndex][field];
  }
  return next;
};

export const clearFieldError = (errorsState, field) => ({
  ...errorsState,
  [field]: "",
});

export const parseDateTimeFlexible = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return null;

  let d;

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, day] = dateStr.split("-").map(Number);
    d = new Date(y, m - 1, day);
  } else if (/^\d{2}-[A-Za-z]{3}-\d{4}$/.test(dateStr)) {
    const [dayStr, monStr, yStr] = dateStr.split("-");
    const mi = MONTH_IDX[monStr];
    if (mi == null) return null;
    d = new Date(Number(yStr), mi, Number(dayStr));
  } else {
    const maybe = new Date(dateStr);
    if (isNaN(maybe)) return null;
    d = maybe;
  }

  const [hh, mm] = (timeStr || "").split(":").map(Number);
  d.setHours(hh || 0, mm || 0, 0, 0);
  return d;
};

export const hoursBetween = (a, b) =>
  (a.getTime() - b.getTime()) / (1000 * 60 * 60);

export const formatExpiryAt = (dateInput, timeStr) => {
  if (!dateInput || !timeStr) return "";
  const [hours, minutes] = timeStr.split(":").map(Number);
  const date = new Date(dateInput);
  date.setHours(hours || 0, minutes || 0, 0);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return `${formattedDate} ${formattedTime}`;
};

export const formatDate = (dateInput) => {
  if (!dateInput) return "";

  const date = new Date(dateInput);
  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const parseDateString = (dateStr) => {
  if (!dateStr) return "";
  const [day, mon, year] = dateStr.split("-");
  const months = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  };
  const month = months[mon] ?? 0;
  return new Date(year, month, day);
};

export const parseDateToISO = (dateStr) => {
  if (!dateStr) return "";
  const [day, mon, year] = dateStr.split("-");
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };
  const month = months[mon] || "01";
  return `${year}-${month}-${day.padStart(2, "0")}`;
};

export const monthsMap = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11,
};

export const parseDateToJSDate = (dateStr) => {
  if (!dateStr) return null;
  const [day, mon, year] = dateStr.split("-");
  return new Date(year, monthsMap[mon], day);
};

export const validateDateRange = (startDate, endDate) => {
  try {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return start <= end;
  } catch {
    return false;
  }
};


export  const isTimeValid = (start, end) => {
    if (!start || !end) return false;

    // Convert to string and trim
    const startStr = String(start).trim();
    const endStr = String(end).trim();

    const [sh, sm] = startStr.split(":").map(Number);

    let eh, em;
    if (endStr === "24:00") {
      eh = 24;
      em = 0;
    } else {
      [eh, em] = endStr.split(":").map(Number);
    }

    if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) return false;

    if (sh < 0 || sh > 23) return false;
    if (sm < 0 || sm > 59) return false;
    if (em < 0 || em > 59) return false;

    if (endStr === "24:00") {
      if (eh !== 24 || em !== 0) return false;
    } else {
      if (eh < 0 || eh > 23) return false;
    }

    const startMinutes = sh * 60 + sm;
    const endMinutes = eh * 60 + em;

    return endMinutes > startMinutes;
  };

export const validateTimeRange = (startTime, endTime) => {
  return isTimeValid(startTime, endTime);
};

export const isDateInFuture = (dateStr, timeStr) => {
  try {
    const dt = parseDateTimeFlexible(dateStr, timeStr);
    return dt && dt > new Date();
  } catch {
    return false;
  }
};

export const isDateToday = (dateStr) => {
  try {
    const date = new Date(dateStr);
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  } catch {
    return false;
  }
};

export const isTimeAtLeast3HoursFromNow = (dateStr, timeStr) => {
  if (!isDateToday(dateStr)) return true;
  try {
    const dt = parseDateTimeFlexible(dateStr, timeStr);
    const threeHoursLater = new Date(new Date().getTime() + 3 * 60 * 60 * 1000);
    return dt && dt >= threeHoursLater;
  } catch {
    return false;
  }
};
